import './Unauthorized.scss';

const Unauthorized = () => {
  return (
    <div>
      <h1>Unauthorized</h1>
    </div>
  );
};

export default Unauthorized;
